/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { BsCheckCircle } from "react-icons/bs";
import { AiOutlineLoading, AiOutlineCloseCircle } from "react-icons/ai";

import { codeOk, errorMessage } from "../../../../middlewares/index";
import { useUserContext } from "../../../../context/user/UserContext";

import {
  Title,
  GoBack,
  InputField,
  PhoneInput,
} from "../../component/Component";

const Add = () => {
  const { createOneUser } = useUserContext();

  const [error, setError] = useState(false);
  const [status, setStatus] = useState(0);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [email, setEmail] = useState(0);
  const [phone, setPhone] = useState(0);
  const [password, setPassword] = useState(0);

  const userRoutes = "/user";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);

    setFirstName(null);
    setLastName(null);
    setEmail(null);
    setPhone(null);
    setPassword(null);
  };

  const responses = (isError, _status, _message) => {
    setError(isError);
    setStatus(_status);
    setErrorMessage(_message);
  };

  const addOneTourPackageHandler = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!firstName || firstName === "") {
      responses(true, 400, "First Name is required");
      setLoading(false);
    } else if (!lastName || lastName === "") {
      responses(true, 400, "Last Name is required");
      setLoading(false);
    } else if (!email || email === "") {
      responses(true, 400, "Email is required");
      setLoading(false);
    } else if (!phone || phone === "") {
      responses(true, 400, "Phone is required");
      setLoading(false);
    } else if (!password || password === "") {
      responses(true, 400, "Password is required");
      setLoading(false);
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      phone: phone,
      password: password,
    };

    const response = await createOneUser(data);
    if (response) {
      if (response.data.status === codeOk) {
        cleanFields();
        return responses(false, response.data.status, response.data.message);
      } else {
        setLoading(false);
        return responses(true, response.data.status, response.data.message);
      }
    } else {
      setLoading(false);
      return responses(true, 400, errorMessage);
    }
  };

  const Banner = () => {
    if (!error && !success) return null;

    const isOk = status === codeOk;
    return (
      <div
        className={[
          "relative w-full overflow-hidden rounded-2xl border p-4 shadow-sm",
          isOk
            ? "border-emerald-200 bg-emerald-50"
            : "border-rose-200 bg-rose-50",
        ].join(" ")}
        role="alert"
      >
        <div
          className={[
            "absolute inset-x-0 top-0 h-1",
            isOk ? "bg-emerald-500/80" : "bg-rose-500/80",
          ].join(" ")}
        />
        <div className="flex items-start gap-3">
          <div
            className={[
              "grid h-8 w-8 place-items-center rounded-md text-white",
              isOk ? "bg-emerald-600" : "bg-rose-600",
            ].join(" ")}
          >
            {isOk ? (
              <BsCheckCircle className="h-5 w-5" />
            ) : (
              <AiOutlineCloseCircle className="h-5 w-5" />
            )}
          </div>
          <div className="min-w-0">
            <p
              className={[
                "text-sm font-semibold",
                isOk ? "text-emerald-900" : "text-rose-900",
              ].join(" ")}
            >
              {isOk ? "Success" : "Error"}
            </p>
            <p className="mt-0.5 text-xs text-gray-700 break-words">
              {message}
            </p>
          </div>
          <button
            type="button"
            className="ml-auto rounded-md px-2 py-1 text-xs text-gray-600 hover:bg-white/60"
            onClick={() => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            }}
          >
            Close
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="h-full overflow-y-auto bg-gray-50 p-4 rounded-b-xl">
      <div className="mx-auto max-w-3xl space-y-5">
        <GoBack props={{ route: userRoutes }} />

        {/* Header */}
        <div className="relative">
          <div className="pointer-events-none absolute -inset-x-6 -top-6 h-24 rounded-3xl bg-gradient-to-r from-emerald-400/15 via-amber-400/15 to-fuchsia-400/15 blur-2xl -z-10" />
          <div className="relative rounded-2xl border border-gray-200 bg-white/90 shadow-sm backdrop-blur">
            <div className="flex items-center justify-between p-5">
              <div>
                <h1 className="text-base font-semibold tracking-tight text-gray-900">
                  Add User
                </h1>
                <p className="mt-0.5 text-xs text-gray-600">
                  Create a new user by providing basic account details.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Alerts */}
        <Banner />

        {/* Form */}
        <form onSubmit={addOneTourPackageHandler}>
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
            <div className="p-4 md:p-5">
              <Title props={{ title: "User Details" }} />

              <div className="mt-3 grid grid-cols-1 gap-4 md:grid-cols-2">
                <InputField
                  props={{
                    id: "first_name",
                    title: "First Name",
                    type: "text",
                    value: firstName ? firstName : "",
                    onChange: (e) => {
                      setFirstName(e.target.value);
                      setError(false);
                      setSuccess(false);
                    },
                  }}
                />
                <InputField
                  props={{
                    id: "last_name",
                    title: "Last Name",
                    type: "text",
                    value: lastName ? lastName : "",
                    onChange: (e) => {
                      setLastName(e.target.value);
                      setError(false);
                      setSuccess(false);
                    },
                  }}
                />
                <InputField
                  props={{
                    id: "email",
                    title: "Email Address",
                    type: "email",
                    value: email ? email : "",
                    onChange: (e) => {
                      setEmail(e.target.value);
                      setError(false);
                      setSuccess(false);
                    },
                  }}
                />

                <PhoneInput setPhone={setPhone} phone={phone} required={true} />

                <InputField
                  props={{
                    id: "password",
                    title: "Password",
                    type: "password",
                    value: password ? password : "",
                    onChange: (e) => {
                      // keep logic intact while making UI better
                      setPassword(e.target.value);
                      setError(false);
                      setSuccess(false);
                    },
                  }}
                />
              </div>
            </div>

            <div className="border-t border-gray-100 p-4">
              {loading ? (
                <button
                  type="button"
                  className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-gradient-to-br from-blue-600 to-blue-500 px-5 py-3 text-sm font-semibold text-white shadow-sm hover:from-blue-700 hover:to-blue-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-300 md:w-44"
                >
                  <AiOutlineLoading className="h-4 w-4 animate-spin" />
                  Saving…
                </button>
              ) : (
                <button
                  type="submit"
                  className="inline-flex w-full items-center justify-center rounded-lg bg-gradient-to-br from-blue-600 to-blue-500 px-5 py-3 text-sm font-semibold text-white shadow-sm hover:from-blue-700 hover:to-blue-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-300 md:w-44"
                >
                  Add User
                </button>
              )}
            </div>
          </section>
        </form>
      </div>
    </div>
  );
};

export default Add;
